import React, { useContext, useEffect, useState } from "react";
import API from "../../api/phx";
import { getDomainConfig } from "../../config/config";
import { Select } from "../Input/Input";
import StandardButton from "../UI/StandardButton";
import StandardFormItem from "../UI/StandardFormItem";
import StandardInputWrapper from "../UI/StandardInputWrapper";
import StandardLabel from "../UI/StandardLabel";
import StandardValidation from "../UI/StandardValidation";
import { googleDataLayer } from "../Analytics/Universal/PageView/googleDataLayer";
import { ABContext } from "../../contexts/ab-context";
//import styles from "./PostcodeLookup.module.scss";
import { useTranslation } from "react-i18next";

const PostcodeLookup = (props) => {

const { t } = useTranslation('common');
const config = getDomainConfig();

  /* LOADING THE BRANDED SCSS */
const [styles, setStyles] = useState(false);

useEffect(() => {

const getStyles = async (theFileName, theFileEnd) => {
  if (config.brand) {
    let moduleStyles = false;
    try {
      moduleStyles = await import(
        "./" + theFileName + config.brand + theFileEnd
      );
      setStyles(moduleStyles);
    } catch (e) {
      console.error(
        `Styles for ${theFileName} could not be loaded, ${e.message}`
      );
    }
  }
};

  // Specify file name and end of file name here.
  getStyles("PostcodeLookup", ".module.scss");
}, [config.brand]);

/* END LOADING THE BRANDED SCSS */

  const abContext = useContext(ABContext);

  // CRO-1381-checkout-redesign
  const [isCro1381, setIsCro1381] = useState(false);

  useEffect(() => {
    if ((config.brand !== 'Sw') && abContext.cro1381 !== undefined) setIsCro1381(abContext.cro1381.variant);
  }, [abContext]);
  // END CRO-1381-checkout-redesign

  const [postcodeLookUpError, setPostcodeLookUpError] = useState("");
  const [addressResults, setAddressResults] = useState([]);

  const handlePostcodeLookupClick = (event) => {
    // Stop the checkout form submitting.
    const btn = event.target;
    event.preventDefault();
    btn.classList.add("loading");
    const postcode = document.getElementById(
      props.address + "-postcode-lookup"
    ).value.split(' ').join('');
    if (postcode) {
      setPostcodeLookUpError("");
      API.get("/postcode?postcode=" + postcode)
        .then((result) => {
          const addressResults = result.data.data.map((r, i) => {
            return (
              <option
                key={i}
                street1={r.street1}
                street2={r.street2}
                region={r.region}
                city={r.city}
                postcode={r.postcode}
                value={r.street1}
              >
                {r.street1}
              </option>
            );
          });

          setAddressResults(addressResults);
        })
        .catch(() => {
          setPostcodeLookUpError(
            "We’re unable to find your address, please enter it manually"
          );
        });
    }
    btn.classList.remove("loading");
  };

  const handlePostcodeLookupChange = (event) => {
    const selectedOption = event.target.selectedOptions[0];
    const street1 = selectedOption.getAttribute("street1");
    const street2 = selectedOption.getAttribute("street2");
    const region = selectedOption.getAttribute("region");
    const city = selectedOption.getAttribute("city");
    const postcode = selectedOption.getAttribute("postcode");

    const addressType = event.target.getAttribute("id").split("-")[0];

    props.setValue(addressType + "-address-street1", street1,{
      shouldDirty: true,
      shouldTouch: true,
      shouldValidate: true,
    });

    props.setValue(addressType + "-address-street2", street2,{
      shouldDirty: true,
      shouldTouch: true,
      shouldValidate: true,
    });

    props.setValue(addressType + "-address-region", region,{
      shouldDirty: true,
      shouldTouch: true,
      shouldValidate: true,
    });

    props.setValue(addressType + "-address-city", city,{
      shouldDirty: true,
      shouldTouch: true,
      shouldValidate: true,
    });

    props.setValue(addressType + "-address-postal-code", postcode, {
      shouldDirty: true,
      shouldTouch: true,
      shouldValidate: true,
    });

    setTimeout(() => {
      onChangeEventCaller(addressType + "-address-street1");
      onChangeEventCaller(addressType + "-address-street2");
      onChangeEventCaller(addressType + "-address-region", 'input', 'select');
      onChangeEventCaller(addressType + "-address-city");
      onChangeEventCaller(addressType + "-address-postal-code");
    }, 0);
  
    if (props.onAddressSelect) {
      props.onAddressSelect();
    }
  };

  let defaultClass = styles.textInput; // The generic class (in css modules format)
  let classes = defaultClass; // The classes list to show
  let showError = false;
  let showSuccess = false;
  if (props.errors[props.name]) {
    // If validation triggered, add another modules class
    classes = defaultClass + " " + styles.error;
    showError = true;
    showSuccess = false;
  } else if (props.touched) {
    // Input has been touched and is valid.
    classes = defaultClass + " " + styles.success;
    showError = false;
    showSuccess = true;
  }

  if (props.maskingClass) {
    classes = classes + " " + props.maskingClass;
  }

  const onChangeEventCaller = (inputElementName, eventAction='click', field='input') => {
    // Manually trigger the onChange event
    const inputElement = document.querySelector(`${field}[name=${inputElementName}]`);
    if (inputElement) {
      const event = new Event(eventAction, { bubbles: true });
      inputElement.dispatchEvent(event);
    }
  }

  return (
    <React.Fragment>
      <StandardFormItem
        className="textItem"
        id={"edit-panes-" + props.address + "-uc-postcodesoftware-wrapper"}
      >
        <StandardLabel
          htmlFor={"edit-panes-" + props.address + "-uc-postcodesoftware"}
        >
          Find address using your postcode
        </StandardLabel>
        <StandardInputWrapper className={`textWrapper ${isCro1381 && "cro1381HalfForm cro1381AddressInputWrapper"}`}>
          <input
            size="8"
            className={classes}
            name={props.address + "-postcode-lookup"}
            id={props.address + "-postcode-lookup"}
            onClick={props.dataLayerInput}
          />
          <StandardButton
            id={props.address + "-postcode-lookup-btn"}
            className="sideButton postcodeButton"
            value="Find address"
            onClick={handlePostcodeLookupClick}
          >
            Find address
          </StandardButton>

          {showSuccess && (
            <StandardValidation valType="success" icon="true" className="input"></StandardValidation>
          )}
          {postcodeLookUpError !== '' && (
            <StandardValidation className="input" valType="error" icon="true">
              {postcodeLookUpError}
            </StandardValidation>
          )}
        </StandardInputWrapper>
      </StandardFormItem>
      {addressResults.length > 0 && (
        <Select
          initialOption={t("please-select")}
          showInitialOption={true}
          register={props.register}
          errors={props.errors}
          getValues={props.getValues}
          inputSize={32}
          name={props.address + "-postcode-lookup"}
          options={addressResults}
          setValue={props.setValue}
          control={props.control}
          onChange={handlePostcodeLookupChange}
          dataLayerInput={() => googleDataLayer.createUserClickInputEvent("postcode_lookup_address")}
        />
      )}
    </React.Fragment>
  );
};

export default PostcodeLookup;
